import { render, staticRenderFns } from "./BaseDuration.vue?vue&type=template&id=8185ffb8&scoped=true&"
import script from "./BaseDuration.vue?vue&type=script&lang=ts&"
export * from "./BaseDuration.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDuration.vue?vue&type=style&index=0&id=8185ffb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8185ffb8",
  null
  
)

export default component.exports